"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFacebookLogin = void 0;
var react_1 = require("react");
var fbClient_1 = require("./helpers/fbClient");
var ssr_1 = require("./helpers/ssr");
var loadSdk_1 = require("./sdk/loadSdk");
function useFacebookLogin(options) {
    var _a;
    var _b = (0, react_1.useState)(false), ready = _b[0], setReady = _b[1];
    var _c = (0, react_1.useState)(false), busy = _c[0], setBusy = _c[1];
    var dialogParams = __assign(__assign({ redirect_uri: (0, ssr_1.isClientSide)() ? location.origin + location.pathname : "/", state: fbClient_1.DIALOG_PARAMS_STATE, response_type: "code" }, options.dialogParams), { client_id: options.appId });
    var loginOptions = __assign(__assign({}, options.loginOptions), { scope: (_a = options.scope) !== null && _a !== void 0 ? _a : "public_profile,email" });
    (0, react_1.useEffect)(function () {
        function init() {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var version, error_1;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            version = (_b = (_a = options.sdkInitParams) === null || _a === void 0 ? void 0 : _a.version) !== null && _b !== void 0 ? _b : "v16.0";
                            _d.label = 1;
                        case 1:
                            _d.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, (0, loadSdk_1.loadSdk)(options.language || "en_US", version, options.appId)];
                        case 2:
                            _d.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _d.sent();
                            (_c = options.onInitError) === null || _c === void 0 ? void 0 : _c.call(options, error_1);
                            return [2 /*return*/];
                        case 4:
                            setReady(true);
                            window.fbAsyncInit = function () {
                                (0, fbClient_1.getFB)().init(__assign(__assign({ version: version }, options.sdkInitParams), { appId: options.appId }));
                                if ((0, fbClient_1.isRedirected)(dialogParams) && options.useRedirect) {
                                    requestLogin();
                                }
                            };
                            return [2 /*return*/];
                    }
                });
            });
        }
        init();
    }, []);
    function logIn() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!options.appId) {
                    throw new Error("App ID is required.");
                }
                if (options.useRedirect) {
                    (0, fbClient_1.redirectToDialog)(dialogParams, loginOptions);
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, requestLogin()];
            });
        });
    }
    function requestLogin() {
        setBusy(true);
        return new Promise(function (resolve, reject) {
            try {
                (0, fbClient_1.getFB)().login(function (res) {
                    setBusy(false);
                    resolve(res);
                }, loginOptions);
            }
            catch (error) {
                reject(error);
                setBusy(false);
            }
        });
    }
    function logOut() {
        return new Promise(function (resolve, reject) {
            try {
                (0, fbClient_1.getFB)().logout(function (response) { return resolve(response); });
            }
            catch (error) {
                reject(error);
            }
        });
    }
    function getProfile() {
        return new Promise(function (resolve, reject) {
            var _a;
            try {
                (0, fbClient_1.getFB)().api("me", { fields: (_a = options.fields) !== null && _a !== void 0 ? _a : "name,email,picture" }, function (res) { return resolve(res); });
            }
            catch (error) {
                reject(error);
            }
        });
    }
    return { ready: ready, busy: busy, logIn: logIn, logOut: logOut, getProfile: getProfile };
}
exports.useFacebookLogin = useFacebookLogin;
